<template>
  <a v-tooltip="{ content: `${banner.title} - ${banner.description}` }" class="h-display-inline-block" v-if="banner" :href="banner.link" target="_blank" @click="recordClick"><img :src="imageUrl" /></a>
</template>

<script>
  export default {
    name: 'NewsBanner',
    props: ['banner'],
    computed: {
      imageUrl() {
        return this.banner.file_paths[0].file_url;
      },
    },
    methods: {
      recordClick() {
        this.$store.dispatch('banners/recordClick', this.banner);
      },
    },
  };
</script>

<style lang="scss" scoped>
  img {
    max-width: 100%;
  }
</style>
